import { FC } from 'react';
import { IconProps } from '@base/icon/interface';
import { SVG } from '@base/icon/SVG';

export const IconPlus: FC<IconProps> = props => (
    <SVG
        {...props}
        path="M512 170.666667a42.666667 42.666667 0 0 1 42.666667 42.666666v256h256a42.666667 42.666667 0 0 1 0 85.333334h-256v256a42.666667 42.666667 0 0 1-85.333334 0v-256h-256a42.666667 42.666667 0 0 1 0-85.333334h256v-256A42.666667 42.666667 0 0 1 512 170.666667z"
    />
);